/**
 * Question à poser à l'assistant du chat depuis une autre partie du site (ex. la
 * recherche du centre d'aide). Le chat (PublicChatWidget) la récupère, s'ouvre
 * et la met dans son champ de saisie ; le visiteur n'a plus qu'à envoyer.
 */
export function useQuestionPourChat() {
  return useState<string | null>("chat-question-a-poser", () => null);
}
